export const ORDER_PROCESSING = 'processing';
export const ORDER_SHIPPED = 'shipped';
export const ORDER_RETURNED = 'returned';
export const ORDER_PARTIALLY_RETURNED = 'partially returned';
